<app-resp-popup-title
  ><mat-icon>folder</mat-icon>
  <span i18n="@@Infoportal_Receipt_FolderCreate_Title"
    >Create a new folder</span
    ></app-resp-popup-title
    >
    <app-resp-popup-content
      >@if (!loading) {
      <form
        [formGroup]="form"
        style="width: 500px; max-width: 100%; position: relative"
        >
        <div class="row">
          <div class="col">
            <frm-text
              i18n-label="@@Infoportal_Receipt_FolderCreate_Label"
              label="Label"
              formControlName="label"
            ></frm-text>
          </div>
        </div>
        <div class="row">
          <div class="col">
            <frm-text
              i18n-label="@@Infoportal_Receipt_FolderCreate_Description"
              label="Description"
              formControlName="description"
              [multiline]="true"
              [rows]="5"
            ></frm-text>
          </div>
        </div>
        <div class="row">
          <div class="col">
            <frm-infoportal-tags-select
              formControlName="tagIDs"
            ></frm-infoportal-tags-select>
          </div>
        </div></form
        >
      } @else {
        <app-shimmer [isLoading]="true" type="custom">
          <ng-template shimmerPreviewTemplate>
            <app-shimmer-label></app-shimmer-label>
            <app-shimmer-input></app-shimmer-input>
            <app-shimmer-label></app-shimmer-label>
            <app-shimmer-input height="170px"></app-shimmer-input>
          </ng-template>
        </app-shimmer>
      }</app-resp-popup-content>
      <app-resp-popup-actions>
        @if (!loading) {
          <div>
            <ctrl-btn-accept
              [disabled]="!canAccept()"
              (click)="onAccept()"
            ></ctrl-btn-accept>
            <ctrl-btn-cancel (click)="onCancel()"></ctrl-btn-cancel>
          </div>
        } @else {
          <app-shimmer [isLoading]="true" type="custom">
            <ng-template shimmerPreviewTemplate>
              <app-shimmer-input
                width="200px"
                style="display: inline-block"
              ></app-shimmer-input>
              <app-shimmer-input
                width="200px"
                style="display: inline-block"
              ></app-shimmer-input>
            </ng-template>
          </app-shimmer>
        }
      </app-resp-popup-actions>


